export const EVENT_LEVELS = ['FATAL', 'WARNING', 'INFORM'];
export const EVENT_METHOD = ['MAIL', 'SMS', 'MESSENGER'];
export const NOTIFY_METHOD = {
  SEND_RESULT: {
    NOT_SEND: 'NOT SEND',
    FAIL: 'FAIL',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    NOT_PERMISSION: 'NOT_PERMISSION',
    FILTERED: 'FILTERED'
  },
  METHOD: {
    MAIL: 'MAIL',
    MESSENGER: 'MESSENGER',
    SMS: 'SMS'
  }
};
export const AGENT_TYPES = {
  PERFORMANCE: 'metricbeat',
  LOG: 'filebeat',
  WIN_EVENT: 'winlogbeat'
};
// =================== Begin constants of product ==============

export const PRODUCT_TYPE_GROUPS = [
  { name: 'Compute', img: '01_ProductGroup_Compute' },
  { name: 'Storage', img: '01_ProductGroup_Storage' },
  // { name: 'Data Analytics', img: '01_ProductGroup_Analytics' },
  { name: 'Container', img: '01_ProductGroup_Container' },
  { name: 'Networking', img: '01_ProductGroup_Networking' },
  { name: 'Database', img: '01_ProductGroup_Database' }
];

export const DATA_ANALYTICS_GROUP = 'Data Analytics';

// list of product types
export const VM = 'VM';
export const KUBERNETES = 'Kubernetes';
export const LOAD_BALANCER = 'Load Balancer';
export const LB = 'LB';
export const DATA_OPS = 'DataOps';
export const DATA_FLOW = 'DataFlow';
export const QUICK_QUERY = 'QuickQuery';
export const DATA_WRANGLER = 'DataWrangler';

export const VPC = 'VPC';
export const DIRECT_CONNECT = 'DC';
export const TRANSIT_GATEWAY = 'TGW';
export const FILE_STORAGE = 'File Storage';
export const FILE_STORAGE_NEW = 'File Storage(New)';
export const CONTAINER_REGISTRY = 'Container Registry';
export const APACHE_KAFKA = 'KAFKA';
export const CLOUD_FUNCTIONS = 'Cloud Functions';
export const HPC_CLUSTER = 'HPCCluster';
export const CLOUD_WAN = 'WAN';
export const VPN = 'VPN';
export const GLOBAL_CDN = 'CDN';
export const OBJECT_STORAGE = 'Object Storage';
export const CLOUD_HADOOP = 'Hadoop';
export const DATA_CATALOG = 'DataCatalog';
export const BARE_MENTAL_SERVER = 'Bare Metal Server';
export const INTERNET_GATEWAY = 'IGW';
export const OPENSEARCH = 'Opensearch';
export const BLOCK_STORAGE_BM = 'Block Storage(BM)';
export const BLOCK_STORAGE_VM = "Block Storage(VM)";
export const POSTGRESQL = "PostgreSQL";
export const VERTICA = "Vertica";
export const MULTINODE_GPU = "MULTINODE-GPU";
export const MARIADB = "MariaDB";
export const MYSQL = "MySQL";
export const EPAS = "EPAS";
export const MS_SQL = "MS-SQL";
export const REDIS = "Redis";
export const VALKEY = "Valkey";
export const ELASTICSEARCH = "Elasticsearch";

// list of object types
export const OT_DEPLOYMENT = 'deployment';
export const OT_STATEFULSET = 'statefulset';
export const OT_DAEMONSET = 'daemonset';
export const OT_CRONJOB = 'cronjob';
export const OT_JOB = 'job';
export const OT_REPLICASET = 'replicaset';
export const OT_CLUSTER = 'cluster';
export const OT_SERVICE = 'service';
export const OT_NAMESPACE = 'namespace';
export const OT_POD = 'pod';
export const OT_SERVER_GROUP = 'servergroup';
export const OT_NODE = 'node';
export const OT_LISTENER = 'Listener';

export const PREFIX_MAP_PRODUCT_TYPES = {
  [KUBERNETES]: 'Cluster: ',
  [LOAD_BALANCER]: 'Service: ',
  [DATA_OPS]: 'Service: ',
  [DATA_FLOW]: 'Service: ',
  [QUICK_QUERY]: 'Instance:',
  [DATA_WRANGLER]: 'Instance:'
};

export const PREFIX_MAP_PRODUCT_TYPES_V2 = {
  [KUBERNETES]: 'Cluster',
  [LOAD_BALANCER]: 'Service',
  [DATA_OPS]: 'Service/Manager',
  [DATA_FLOW]: 'Service/Manager',
  [QUICK_QUERY]: 'Namespace',
  [DATA_WRANGLER]: 'Namespace'
};

export const PRODUCT_SUB_TYPE_OBJECT_NAME = [
  ['Kubernetes', 'cluster'],
  ['QuickQuery', 'namespace'],
  ['DataWrangler', 'namespace'],
  ['DataFlow', 'service'],
  ['DataOps', 'service'],
  ['Load Balancer', 'service']
];

export const PRODUCT_TYPES_WITH_OBJECT_TYPES = [
  KUBERNETES,
  LOAD_BALANCER,
  DATA_OPS,
  DATA_FLOW,
  QUICK_QUERY,
  DATA_WRANGLER
];
export const PRODUCT_TYPES_WITH_K8S = [KUBERNETES, QUICK_QUERY, DATA_WRANGLER];
export const SUB_OBJECT_TYPES_WITH_K8S = [
  OT_DEPLOYMENT,
  OT_STATEFULSET,
  OT_DAEMONSET,
  OT_CRONJOB,
  OT_JOB,
  OT_REPLICASET,
  OT_NODE
];
export const OBJECT_TYPES_WITHOUT_SUB = [
  {
    productTypes: [KUBERNETES],
    objectTypes: [OT_CLUSTER]
  },
  {
    productTypes: [DATA_OPS, DATA_FLOW],
    objectTypes: [OT_SERVICE]
  },
  {
    productTypes: [LOAD_BALANCER],
    objectTypes: [OT_SERVICE, OT_LISTENER]
  },
  {
    productTypes: [QUICK_QUERY, DATA_WRANGLER],
    objectTypes: [OT_NAMESPACE]
  }
];

export const PRODUCT_TYPES = {
  VM,
  KUBERNETES,
  LOAD_BALANCER,
  LB,
  DATA_OPS,
  DATA_FLOW,
  QUICK_QUERY,
  DATA_WRANGLER,
  VPC,
  DIRECT_CONNECT,
  TRANSIT_GATEWAY,
  FILE_STORAGE_NEW,
  CONTAINER_REGISTRY,
  APACHE_KAFKA,
  CLOUD_FUNCTIONS,
  HPC_CLUSTER,
  CLOUD_WAN,
  VPN,
  GLOBAL_CDN,
  OBJECT_STORAGE,
  OPENSEARCH
};

export const PRODUCTS_STATE = {
  RUNNING: 'Running',
  READY: 'Ready',
  DOWN: 'Down',
  NOT_READY: 'Not Ready',
  NE: 'NE',
  DELETING: 'Deleting',
  RESIZING: 'Resizing',
  UNKNOWN: 'Unknown'
};

export const SORT_TYPES = {
  ASC: 'asc',
  DESC: 'desc'
};

export const PERFORMANCE_STATE_DISABLED = [PRODUCTS_STATE.DELETING, PRODUCTS_STATE.RESIZING];
export const IGNORE_ELEMENTS = ['lego-table'];

export const MONITORING_WIDGET_URL = 'performanceList';

export const COMMON_CUSTOMIZE_LABELS = {
  [CLOUD_WAN]: [
    { field: "productName", tranKey: "attachmentName" }
  ],
  [OPENSEARCH]: [
    { field: "dbVersion", tranKey: "version" },
    { field: "type", tranKey: "severType" }
  ],
  [BLOCK_STORAGE_BM]: [
    { field: "diskSize", tranKey: "capacity" }
  ],
  [BLOCK_STORAGE_VM]: [
    { field: "diskSize", tranKey: "capacity" }
  ],
  [POSTGRESQL]: [
    { field: "type", tranKey: "severType" }
  ],
  [VERTICA]: [
    { field: "type", tranKey: "severType" }
  ],
  [FILE_STORAGE]: [
    { field: "type", tranKey: "diskType" }
  ],
  [VM]: [
    { field: "type", tranKey: "severType" }
  ],
  [BARE_MENTAL_SERVER]: [
    { field: "type", tranKey: "severType" }
  ],
  [MULTINODE_GPU]: [
    { field: "type", tranKey: "severType" }
  ],
  [MARIADB]: [
    { field: "type", tranKey: "severType" }
  ],
  [MYSQL]: [
    { field: "type", tranKey: "severType" }
  ],
  [EPAS]: [
    { field: "type", tranKey: "severType" }
  ],
  [MS_SQL]: [
    { field: "type", tranKey: "severType" }
  ],
  [REDIS]: [
    { field: "type", tranKey: "severType" }
  ],
  [VALKEY]: [
    { field: "type", tranKey: "severType" }
  ],
  [APACHE_KAFKA]: [
    { field: "type", tranKey: "severType" }
  ],
  [ELASTICSEARCH]: [
    { field: "type", tranKey: "severType" },
    { field: "dbVersion", tranKey: "version" },
  ],
}

// =================== End up constants of product ==============
